export enum NotificationOptionsType  {
	error = "error",
	success = "success",
	warn = "warn"
}
